<div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-row align-items-center position-relative">
  <lib-auth-language-switcher></lib-auth-language-switcher>
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="6" xl="4">
        <!-- Verifying State -->
        @if (isVerifying()) {
          <div class="text-center py-5">
            <c-spinner color="primary" variant="grow"></c-spinner>
            <p class="mt-3 h6 text-body-secondary">{{ 'reset_password.verifying_link' | translate }}</p>
          </div>
        }

        <!-- Success State -->
        @if (success()) {
          <c-card class="p-4 shadow-sm border-0">
            <c-card-body class="text-center">
              <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

              <h3 class="mb-3 text-success">{{ 'reset_password.success_title' | translate }}</h3>

              <c-alert color="success" class="mb-4">
                <p class="mb-0">
                  {{ 'reset_password.success_message' | translate }}
                </p>
              </c-alert>

              <p class="text-body-secondary mb-4">
                {{ 'reset_password.redirecting' | translate }}...
              </p>

              <button
                cButton
                color="primary"
                class="w-100"
                (click)="backToLogin()"
              >
                {{ 'reset_password.go_to_login_now' | translate }}
              </button>
            </c-card-body>
          </c-card>
        }

        <!-- Invalid Token / Error State -->
        @if (!tokenValid() && !isVerifying() && !success()) {
          <c-card class="p-4 shadow-sm border-0">
            <c-card-body class="text-center">
              <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

              <h3 class="mb-3 text-danger">{{ 'reset_password.invalid_link_title' | translate }}</h3>

              <c-alert color="danger" class="mb-4">
                @if (error()) {
                  {{ error() }}
                } @else {
                  {{ 'reset_password.invalid_link_message' | translate }}
                }
              </c-alert>

              <div class="d-grid gap-2 mt-4">
                <button
                  cButton
                  color="primary"
                  (click)="backToLogin()"
                >
                  {{ 'reset_password.back_to_login' | translate }}
                </button>

                <a
                  routerLink="/forgot-password"
                  class="text-decoration-none text-center"
                >
                  {{ 'reset_password.request_new_link' | translate }}
                </a>
              </div>
            </c-card-body>
          </c-card>
        }

        <!-- Password Reset Form -->
        @if (tokenValid() && !success() && !isVerifying()) {
          <c-card class="p-4 shadow-sm border-0">
            <c-card-body>
              <form cForm (ngSubmit)="resetPassword()">
                <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

                <h3 class="mb-3">{{ 'reset_password.title' | translate }}</h3>
                <p class="text-body-secondary mb-4">
                  {{ 'reset_password.enter_new_password' | translate }}
                </p>

                <!-- New Password -->
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input
                    cFormControl
                    [(ngModel)]="password"
                    name="password"
                    type="password"
                    [placeholder]="'reset_password.new_password_placeholder' | translate"
                    unassistedInput
                    [disabled]="isLoading()"
                    required
                  />
                </c-input-group>

                <!-- Confirm Password -->
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input
                    cFormControl
                    [(ngModel)]="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    [placeholder]="'reset_password.confirm_password_placeholder' | translate"
                    unassistedInput
                    [disabled]="isLoading()"
                    required
                  />
                </c-input-group>

                <!-- Error -->
                @if (error()) {
                  <c-alert color="danger" class="mb-3">
                    {{ error() }}
                  </c-alert>
                }

                <!-- Submit -->
                <button
                  cButton
                  color="primary"
                  type="submit"
                  class="w-100"
                  [disabled]="isLoading() || !password() || !confirmPassword() || !passwordsMatch()"
                >
                  @if (isLoading()) {
                    <c-spinner size="sm" class="me-2"></c-spinner>
                    {{ 'reset_password.processing' | translate }}
                  } @else {
                    {{ 'reset_password.reset_password_button' | translate }}
                  }
                </button>

                <!-- Back Link -->
                <div class="text-center mt-3">
                  <button
                    cButton
                    color="link"
                    type="button"
                    (click)="backToLogin()"
                    [disabled]="isLoading()"
                  >
                    {{ 'reset_password.back_to_login' | translate }}
                  </button>
                </div>
              </form>
            </c-card-body>
          </c-card>
        }
      </c-col>
    </c-row>
  </c-container>
</div>